import React from 'react'
import { isEmpty } from 'lodash'
import { Button, BUTTON_SIZES } from 'shared/UI/Button'

const CalendarLink = ({serviceName, url}) => {
  
  const handleClick = () => {
    window.open(url, 'blank')
  }

  return (
    <Button
      className={'calendar-button'}
      size={BUTTON_SIZES.medium}
      disabled = {isEmpty(url)}
      onClick={handleClick}>
      {serviceName}
    </Button>
  )
}

export default CalendarLink
